<div
  class="uploader-root compact"
  data-testid="invoice-ocr-uploader"
>
  @if (loading()) {
    <mat-progress-spinner
      mode="indeterminate"
      data-testid="invoice-ocr-loading"
      [diameter]="56"
    ></mat-progress-spinner>
  }

  @if (!loading()) {
    <div
      class="upload-area"
      dropzone
      role="button"
      tabindex="0"
      data-testid="invoice-ocr-dropzone"
      (dropped)="fileDropped($event)"
      (click)="upload.click()"
      (keydown.enter)="upload.click()"
      (keydown.space)="upload.click(); $event.preventDefault()"
    >
      <input
        #upload
        hidden
        type="file"
        multiple
        accept="application/pdf,
        image/png,
        image/jpeg,
        image/webp"
        data-testid="invoice-ocr-file-input"
        (change)="fileDropped(upload.files)"
      />
      <div class="dropzone-box">
        <div
          class="compact-icon-wrap"
          aria-hidden="true"
        >
          <mat-icon class="compact-icon">upload_file</mat-icon>
        </div>
        <div class="compact-text">
          <div class="compact-title">
            {{ "CASE_FORM.FORMS.INVOICE.COMPACT_UPLOAD_TITLE" | translate }}
          </div>
          <div class="compact-subtitle">
            {{ "CASE_FORM.FORMS.INVOICE.COMPACT_UPLOAD_SUBTITLE" | translate }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
